// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__37jgR","bannerImage":"Banner_bannerImage__joF5k"};